interface ChangeImageWhenHoverProps {
  handleClick?: () => void;
  frameClassName: string;
  src: string;
  alt: string;
}

export const ChangeImageWhenHover = ({ handleClick, frameClassName, src, alt }: ChangeImageWhenHoverProps) => {
  return (
    <div className={`relative ${frameClassName}`} onClick={handleClick}>
      <img className="absolute cursor-pointer hover:opacity-0" src={`${src}.webp`} alt={alt} />
      <img className="absolute cursor-pointer opacity-0 hover:opacity-100" src={`${src}_hover.webp`} alt={alt} />
    </div>
  );
};
